export default "__VITE_ASSET__BpKv6HoK__"